<template>
    <div class="check-box" :data-checked="checked" :data-all="all">
        
    </div>
</template>

<script>
    export default {
        name: "check-box",
        props: {
            checked: {
                default: true
            },
            all: {
                default: false
            }
        },
        data: function () {
            return {}
        },
        methods: {},
        computed: {}
    }
</script>

<style scoped>


    .check-box {
        display: inline-block;
        border: 2px solid #222222;
        border-radius: 0.2em;
        width: 1em;
        height: 1em;
        position: relative;

    }

    .check-box[data-all="true"][data-checked="true"]:after {
        content: none;
    }

    .check-box[data-all="true"]:after {
        content:"–";
        position: absolute;
        width: 100%;
        line-height: 1em;
        text-align: center;
        background-image: none;

        background-color: white;
        border-color: #222;
        background-repeat: no-repeat;

    }

    .check-box[data-checked="true"] {
        background-image: url(../assets/check-icon.svg);
        background-size: 0.8em 0.8em;
        background-position: center;
        background-color: var(--color-blue-lighter);
        border-color: var(--color-blue-lighter);
        background-repeat: no-repeat;

    }

</style>